module.exports = __webpack_public_path__ + "3fd36d3b399f71f9ec55d71c1a765ca2.xlsx";